export default __webpack_public_path__ + "search-overview-final-product-960-3f56dbc61bf654972175199d94df873d.webp";